import React, { useEffect, useState } from 'react';
import Moment from 'moment'
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { RotatingLines } from 'react-loader-spinner';


const SchedulePickup = ({ setSelectedTime, setSelectedDate, isLoading, dropLocations, pickupLocations, quoteData, packageItem, handleBackSteps, handleSteps }: any) => {


  const today = Date.now()
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleRightScroll = () => {
    if (currentIndex < packageItem.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleLeftScroll = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  };

  const [data, setData] = useState([
    { time: "10.00 AM - 12.00 AM", active: false },
    { time: "12.00 AM - 2.00 PM", active: false },
    { time: "2.00 PM - 4.00 PM", active: false },
    { time: "4.00 PM - 6.00 PM", active: false }
  ])

  const [data1, setData1] = useState([
    { date: Moment().add(0, 'days').format("DD"), week: 'M', active: false },
    { date: Moment().add(1, 'days').format("DD"), week: 'Tu', active: false },
    { date: Moment().add(2, 'days').format("DD"), week: 'W', active: false },
    { date: Moment().add(3, 'days').format("DD"), week: 'Th', active: true },
    { date: Moment().add(4, 'days').format("DD"), week: 'F', active: false },
    { date: Moment().add(5, 'days').format("DD"), week: 'Sa', active: false },
    { date: Moment().add(6, 'days').format("DD"), week: 'Sa', active: false }])

  const handleTiming = (e: any) => {
    const newTime = data.map(p =>
      p.time === e
        ? { ...p, active: true }
        : { ...p, active: false }
    );
    setData(newTime)
  }

  const handleDay = (e: any) => {

    const newDay = data1.map(p =>
      p.date === e
        ? { ...p, active: true }
        : { ...p, active: false }
    );
    setData1(newDay)

  }
  useEffect(() => {
    const activeDate = data1.find((item) => item.active);
    if (data1 && activeDate) {
      const currentYear = new Date().getFullYear(); // Get the current year dynamically
      const currentMonth = new Date().getMonth() + 1; // Get the current month 
      const fullDate = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${activeDate.date}`;
      setSelectedDate(fullDate);
    }
  }, [data1]);

  useEffect(() => {
    const activeDate = data.find((item) => item.active);
    if (data && activeDate) {
      setSelectedTime(activeDate?.time);
    }
  }, [data])

  return (
    <div className="flex  flex-col justify-center items-center h-[450px]">
      <div className=" m-3 overflow-auto w-full ">
        <div className="flex flex-col justify-center items-start p-4 space-y-2">
          <div className="text-lg font-semibold">Schedule Pickup</div>
          <div className="text-sm font-normal">Select Date</div>
          <div className="flex flex-wrap w-full">
            {data1.map((obj, index) => (
              <div
                key={index}
                onClick={() => handleDay(Moment().add(index, 'days').format('DD'))}
                className={`p-2 m-2 cursor-pointer w-full max-w-[120px] text-center rounded-md ${obj.active ? 'bg-primary text-light' : 'bg-slate-200'
                  }`}
              >
                <div className="flex flex-col justify-center items-center space-y-1">
                  <div className="text-lg">{Moment().add(index, 'days').format('DD')}</div>
                  <div className="text-xs">{Moment().add(index, 'days').format('dddd').slice(0, 2)}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-sm font-normal">Select Time</div>
          <div className="flex flex-wrap w-full">
            {data.map((obj, index) => (
              <div
                key={index}
                onClick={() => handleTiming(obj.time)}
                className={`text-xs cursor-pointer p-2 m-2 text-center w-full max-w-[100px] rounded ${obj.active ? 'bg-primary text-light' : 'bg-slate-200'
                  }`}
              >
                {obj.time}
              </div>
            ))}
          </div>

          <div className="w-full flex justify-between space-x-3">
            <button
              onClick={handleBackSteps}
              className="flex-grow px-4 py-2 bg-primary text-light text-sm rounded"
            >
              Back
            </button>
            <button
              onClick={handleSteps}
              disabled={isLoading}
              className={`flex-grow flex items-center justify-center px-4 py-2 text-sm text-light rounded ${isLoading ? 'bg-primary bg-opacity-80' : 'bg-primary'
                }`}
            >
              Next
              {isLoading && (
                <div className="ml-2">
                  <RotatingLines
                    visible={true}
                    width="16"
                    strokeColor="#fff"
                    strokeWidth="6"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                  />
                </div>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>

  );
};

export default SchedulePickup;
